import { lookupSizeCurves, getDependencies } from "./size-curves-lookup";
import { Kinds, ValueTypes } from "constants/product-collection";
import { ILookup } from "helpers/merchant/lookup/types";
import { Map } from "immutable";

const kinds: string[] = [Kinds.SIZE_PROFILE_SELECTED, Kinds.DEFAULT_KIND, Kinds.DEPARTMENT_LOOKUP];

export const getInternalLookUp = (
    kind: string,
    settings: ILookup,
    merchantId: string,
    fieldToValueTypeMap?: Map<string, ValueTypes>
) => {
    if (kinds.includes(kind)) {
        return {
            interalLookup: lookupSizeCurves(settings, merchantId, fieldToValueTypeMap),
            getDependencies: getDependencies(settings, false),
        };
    }

    throw new Error(`Unkown internal look up kind: ${kind}`);
};
